import { Card, CardBody, Col, Container, Input, Label, Row, Button } from "reactstrap";
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from "react";
import * as XLSX from 'xlsx';
import { SearchTableButton } from "../../../../utils/Constant";
import api from "../../../../utils/api";
import { AllLockerAssignTableDataColumnType } from "../../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import { AllLockerAssignTableAction, AllLockerAssignTableProductName, AllLockerAssignTableStatus } from "../../../../Data/Application/Ecommerce/AllLockerAssign";
import AllLockerAssignFilterHeader from "../../../../Componant/Application/Ecommerce/ProductList/AllLockerAssignFilterHeader";
import { useNavigate } from "react-router-dom";

const AllLockerAssignContainer = () => {
  const navigate = useNavigate();
  const [filterText, setFilterText] = useState("");
  const [lockerAssignTableDatas, setLockerAssignTableDatas] = useState([]);

  // Pagination-related states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  
  // Get user data
  const userData = (() => {
    try { return JSON.parse(localStorage.getItem("user") || '{}'); } catch { return {}; }
  })();
  const role = userData.role;

  const fetchAllLockerAssigns = async (page: number, size: number, startDate?: string, endDate?: string) => {
    try {
      setLoading(true);
      let response;
      if (role === "Admin") {
        if (startDate) {
          // Use filtered API when dates are provided
          response = await api.get(
            `/api/LockerCalculation/GetAllAssignLockerFilterPagination?startDate=${startDate}&endDate=${endDate}&pageNumber=${page}&pageSize=${size}`
          );
        } else {
          response = await api.get(
            `/api/LockerCalculation/GetAllAssignLockerPagination?pageNumber=${page}&pageSize=${size}`
          );
        }
        if (response.status === 200) {
          setLockerAssignTableDatas(
          response.data.items.map(
            (item: any): AllLockerAssignTableDataColumnType => ({
              lockerCalculationId: item.lockerCalculationId,
              serialNumber: item.serialNumber ?? '',
              bigLocker: item.bigLocker,
              smallLocker: item.smallLocker,
              subTotalAmount: item.subTotalAmount,
              gst: item.gst,
              grandTotalAmount: item.grandTotalAmount,
              isLocked: item.isLocked === true ? "Active" : "Inactive",
              ticketRFIdRef: item.ticketRFIdRef,
              selectedCard: item.selectedCard,
              lockerNumber: item.lockerNumber,
              lockerId: item.lockerId,
              lockerAssignDate: item.lockerAssignDate,
              payableAmount: item.payableAmount,
              refundableAmount: item.refundableAmount,
              customerName: item.customerName ?? "",
              customerMobileNumber: item.customerMobileNumber ?? ""
            })
          )
        );

        // Set total record count from backend
        setTotalRows(response.data.totalCount);
      }
      } else {
        response = await api.get(
          `/api/LockerCalculation/GetAllAssignLockerPagination?pageNumber=${page}&pageSize=${size}`
        );
        if (response.status === 200) {
          setLockerAssignTableDatas(
            response.data.items.map(
              (item: any): AllLockerAssignTableDataColumnType => ({
                lockerCalculationId: item.lockerCalculationId,
                serialNumber: item.serialNumber ?? '',
                bigLocker: item.bigLocker,
                smallLocker: item.smallLocker,
                subTotalAmount: item.subTotalAmount,
                gst: item.gst,
                grandTotalAmount: item.grandTotalAmount,
                isLocked: item.isLocked === true ? "Active" : "Inactive",
                ticketRFIdRef: item.ticketRFIdRef,
                selectedCard: item.selectedCard,
                lockerNumber: item.lockerNumber,
                lockerId: item.lockerId,
                lockerAssignDate: item.lockerAssignDate,
                payableAmount: item.payableAmount,
                refundableAmount: item.refundableAmount,
                customerName: item.customerName ?? "",
                customerMobileNumber: item.customerMobileNumber ?? ""
              })
            )
          );
        }
      }
    } catch (error) {
      console.error("Failed to fetch locker assign:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (startDate) {
      fetchAllLockerAssigns(currentPage, pageSize, startDate, endDate);
    } else {
      fetchAllLockerAssigns(currentPage, pageSize);
    }
  }, [currentPage, pageSize, startDate, endDate]);

  const handleDateSearch = () => {
    if (startDate) {
      setCurrentPage(1);
      fetchAllLockerAssigns(1, pageSize, startDate, endDate);
    } else {
      // If no dates selected, fetch all data
      setCurrentPage(1);
      fetchAllLockerAssigns(1, pageSize);
    }
  };

  const handleDelete = async (id: number) => {
    try {
      await api.put(`/api/LockerCalculation/ReturnRFIDCard?lockerCalculationId=${id}`);
      Swal.fire('Return!', '  Locker has been return submitted.', 'success');

      // Refresh current page data
      await fetchAllLockerAssigns(currentPage, pageSize);
    } catch (error) {
      Swal.fire('Error!', 'Failed to submit return the record.', 'error');
      console.error("Return error:", error);
    }
  };

  const allLockerAssignTableDataColumn: TableColumn<AllLockerAssignTableDataColumnType>[] = [
    {
      name: "S. No.",
      cell: (row) => <AllLockerAssignTableProductName title={row.serialNumber} />,
      sortable: true,
      grow: 4,
      minWidth: '50px',
    },
    {
      name: "Ticket Number",
      cell: (row) => <AllLockerAssignTableProductName title={row.ticketRFIdRef} />,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    // {
    //   name: "RFID Card No.",
    //   selector: (row) => `${row.selectedCard}`,
    //   sortable: true,
    //   grow: 6,
    //   minWidth: '150px',
    // },
    {
      name: "Name",
      selector: (row) => `${row.customerName}`,
      sortable: true,
      grow: 6,
      minWidth: '150px',
    },
    {
      name: "Mobile No.",
      selector: (row) => `${row.customerMobileNumber ?? ""}`,
      sortable: true,
      grow: 6,
      minWidth: '150px',
    },
    {
      name: "Locker Number",
      selector: (row) => `${row.lockerNumber}`,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    {
      name: "Big Locker",
      selector: (row) => `${row.bigLocker}`,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    {
      name: "Small Locker",
      selector: (row) => `${row.smallLocker}`,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    {
      name: "Locker Amount",
      selector: (row) => `${row.subTotalAmount}`,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    {
      name: "Refund Amount",
      selector: (row) => `${row.refundableAmount}`,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    {
      name: "GST",
      selector: (row) => `${row.gst}`,
      sortable: true,
      grow: 2,
    },
    {
      name: "Grand Total Amount",
      selector: (row) => `${row.grandTotalAmount}`,
      sortable: true,
      grow: 6,
      minWidth: '150px',
    },
    {
      name: "Status",
      cell: (row) => <AllLockerAssignTableStatus title={row.isLocked} />,
    },
    {
      name: "Locker Assign Date",
      selector: (row) => `${new Date(row.lockerAssignDate).toLocaleDateString()}`,
      sortable: true,
      grow: 6,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span
            className="bg-info text-white p-2 rounded"
            title="Print Invoice"
            style={{ marginRight: 4, cursor: "pointer" }}
            onClick={() => {
              navigate(`/print-locker-invoice/${row.lockerCalculationId}`);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 8V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v2H3v8h4v4h10v-4h4V8h-2zm-2 10H7v-4h10v4zm2-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2-4H7V6h10v2z" />
            </svg>
          </span>
          <AllLockerAssignTableAction lockerCalculationId={row.lockerCalculationId} onDelete={handleDelete} />
        </>
      ),
      grow: 6,
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

  const filteredItems = lockerAssignTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
  });
  const exportToExcel = () => {
    const rowsToExport = filteredItems.map((item: any) => ({
      "S. No.": item.serialNumber,
      "Ticket Number": item.ticketRFIdRef,
      "Name": item.customerName,
      "Mobile No.": item.customerMobileNumber ?? "",
      "Locker Number": item.lockerNumber,
      "Big Locker": item.bigLocker,
      "Small Locker": item.smallLocker,
      "Locker Amount": item.subTotalAmount,
      "Refund Amount": item.refundableAmount,
      "GST": item.gst,
      "Grand Total Amount": item.grandTotalAmount,
      "Status": item.isLocked ? "Locked" : "Unlocked",
      "Locker Assign Date": item.lockerAssignDate
        ? new Date(item.lockerAssignDate).toLocaleDateString()
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(rowsToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'LockerAssign');
    XLSX.writeFile(workbook, 'LockerAssign.xlsx');
  };

  const subHeaderComponentMemo = useMemo(() => (
    <div>
      {/* Date Filter Section */}
      <div className="d-flex align-items-center gap-3 mb-3">
        <div className="d-flex align-items-center">
          <Label className="me-2">Start Date:</Label>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{ width: '150px' }}
          />
        </div>
        <div className="d-flex align-items-center">
          <Label className="me-2">End Date:</Label>
          <Input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{ width: '150px' }}
          />
        </div>
        <Button color="primary" size="sm" onClick={handleDateSearch}>
          Search
        </Button>
      { userData.role === "Admin" && (
        <Button color="success" size="sm" onClick={exportToExcel}>
          Download Excel
        </Button>
      )}
      </div>
      <div className="dataTables_filter">
        <div className="d-flex align-items-center">
          <Label className="me-2">{SearchTableButton}:</Label>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFilterText(e.target.value);
              setCurrentPage(1);
            }}
            type="search"
            value={filterText}
            style={{ minWidth: 250 }}
          />
        </div>
      </div>
    </div>
  ), [filterText, filteredItems, startDate, endDate]);

  const totalDisplayRows = filterText ? filteredItems.length : totalRows;

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <AllLockerAssignFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    columns={allLockerAssignTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalDisplayRows}                   
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AllLockerAssignContainer;
